import Icon from '../components/Icon.vue'

Icon.register({
  gopuram: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 352c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16h-80v-160h-32v-128h-32v-96h-32v96h32v128h32v160h-80v-80c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v80h-80v-160h32v-128h32v-96h-32v96h-32v128h-32v160h-80c-8.8 0-16-7.2-16-16v-128c0-8.8 7.2-16 16-16h16v-112c0-8.8 7.2-16 16-16h16v-80c0-8.8 7.2-16 16-16h16v-112c0-8.8 7.2-16 16-16s16 7.2 16 16v16h64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v112h16c8.8 0 16 7.2 16 16v80h16c8.8 0 16 7.2 16 16v112h16zM232 176v48h48v-48c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zM288 352v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gopuram.js
// module id = 1397
// module chunks = 0